// @ts-nocheck
import { createContext, useContext } from "react";

export const NamedContext = createContext<string[]>([]);
export const useNamedContext = () => useContext(NamedContext);

export const useIsNamedContext = (value: string | string[] | undefined | null) => {
    const namedContext = useNamedContext();

    if (typeof value === "string") {
        return Boolean(value && namedContext.includes(value));
    }

    if (Array.isArray(value)) {
        return Boolean(value.length && value.some(x => namedContext.includes(x)));
    }

    return false;
};
